<template>
  <div class="link__logout">
    <router-link to="logout">Log out</router-link>
  </div>
</template>

<script>
export default {
  name: 'LogoutButton',
}
</script>

<style lang="sass">
  .link__logout {
    a {
      color: $tinybeans-pink;
      font-weight: bold;
      font-family: "houschka-rounded", Sans-serif;
    }
  }
</style>